import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import moment from 'moment'
import Pagination from './../shared/pagination'
export default {
	name: 'client',
	components: {
		Pagination,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			showSelectWarehouse: false,
			status: '',
			handoveraction: '',
			listHandoverData: [],
			listMaxCountdata: [],
			WarehouseErr: '',
			showSelectClient: false,
			othercouriercompany: false,
			isLoading: false,
			is_Loading: false,
			resultCount: '',
			handname: '',
			poid: '',
			awbno: '',
			shippingcompany: '',
			HandoverPersonName: '',
			awbno: '',
			warehousesearch: '',
			warehousename: '',
			CourierCompany: '',
			listWarehouseData: [],
			listCourierData: [],
			listfechhanoverclient: [],
			clientidfetch: '',
			clientid: '',
			qtyerror: false,
			errormsg: false,
			msg: '',
			ClientErr: '',
			isdisableValue: false,
			clientname:'',
			listClientData:[]
		}
	},
	computed: {
		isComplete1() {
			if (this.errormsg == true) {
				return false;
			} else {
				return true;
			}
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		// this.getClientList()
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail.email;
		// var temp = this.useremail.split('/');
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getcourierlist();
		  });
		switch (this.user_type) {
			case 'system_user':
				this.showSelectWarehouse = true;
				this.showSelectClient = true;
				// this.getWarehouseList();
				// this.getClientList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				// this.getClientList();
				// this.getWarehouseList();
				this.getcourierlist();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectWarehouse = false;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		onchange() {
			if (this.CourierCompany && this.CourierCompany == 'Others') {
				this.$prompt("Enter Courier Company").then(text => {
					if (text && text != '' && text != null) {

						this.listCourierData.push({
							'courierid': text.trim(),
							'couriername': text.trim()
						})
						this.CourierCompany = text.trim()
						this.$alert('Courier Company Added', text)
					} else {
						this.$alert('Courier Company Not Added', text)
					}
				})
			}
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// clientSelected() {
		// 	if (this.user_type != 'client_user') {
		// 		this.getcourierlist();
		// 	}},
		checkinput() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				couriername: this.CourierCompany,
				awbnum: this.awbno.trim(),

			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'fetchhandoverclient',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.clientidfetch = result.data.data.clientid;
					if (this.clientidfetch == '' || this.clientidfetch == null || this.clientidfetch == undefined) {
						this.errormsg = true;
						this.msg = result.data.msg;
					} else {
						this.$alertify.success(result.data.msg)
						this.errormsg = false;
					}
				}, error => {
					console.error(error);
				});
		},
		getcourierlist() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousesearch
			}
			this.input = ({
				clientid:this.clientname,
				warehouseid: window.localStorage.getItem("selectedWarehouse")
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listCourierData = result.data.data.rows;
				}, error => {
					console.error(error);
				});
		},
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		getHandoverSearch() {
			this.currentPage = 1;
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		saveHandover() {

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					if (this.showSelectWarehouse == true) {
						this.warehouseid = this.warehousename
					}
					if (this.qtyerror == true) {
						return false;
					}
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'dispatchAWBItems',
							'data': {
								'warehouseid': window.localStorage.getItem("selectedWarehouse"),
								'dispatchedtouser': this.HandoverPersonName,
								'couriername': this.CourierCompany,
								'awbnum': this.awbno.trim(),
								'dispatchedbyuser': this.useremail,
								'clientid': this.clientid


							},
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {
							if (response.data.errorCode == 0) {
								this.is_Loading = false
								this.$alertify.success(response.data.msg)
								this.resetaddDeatilsForm2();
								this.isdisableValue = true;
							} else if (response.data.errorCode == -1) {
								this.is_Loading = false
								this.$alertify.error(response.data.msg)
								this.resetaddDeatilsForm2();
								this.isdisableValue = true;
							}
						})
						.catch((httpException) => {
							console.error('exception is:::::::::', httpException)
						})
				}

			}).catch(() => {
				console.log('errors exist', this.errors)
			});



		},

		resetaddDeatilsForm() {
			this.warehousename = '';
			this.CourierCompany = '';
			this.HandoverPersonName = '';
			this.awbno = '';
			this.clientname='';
			this.$validator.reset();
			this.clientidfetch = '';
			this.msg = '';
			this.errormsg = false;
			this.isdisableValue = false;

		},
		resetaddDeatilsForm2() {
			this.awbno = '';
			this.msg = '';
			this.errormsg = false;
			this.isdisableValue = false;

		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/shipmenthandover/shipmenthandover.component.js